/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer = {
    readonly isRequestMoreImagesEnabled: boolean | null;
    readonly videoPdpEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_viewer">;
    readonly " $refType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$data = PdpRespHeroCarousel_viewer;
export type PdpRespHeroCarousel_viewer$key = {
    readonly " $data"?: PdpRespHeroCarousel_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isRequestMoreImagesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REQUEST_MORE_IMAGES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
    },
    {
      "kind": "ScalarField",
      "alias": "videoPdpEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "videoPdpEnabled"
        }
      ],
      "storageKey": "isEnabled(key:\"videoPdpEnabled\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c681c79343c1215d2fe91cb6f521cfe8';
export default node;
